import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { login, register } from '../utils'


export default function NotFound() {
  // useEffect(() => {
  //   window.history.replaceState({}, '', '/');
  // }, []);

  return (<>
    <h1>404 Page Not Found</h1>
    <p>
      The page you are looking for does not exist.
    </p>
  </>)
}